module.exports = __webpack_public_path__ + "static/media/13faf0ae-dcab-4d1c-9c08-f9ca339b6023-greek.c7736c0c.woff";